import React from 'react'
import { ArrowLeftIcon } from '@primer/octicons-react'
import { Link } from 'gatsby'

const OtherLists = ({ distrito }) => {
  return (
    <div className="text-center">
      <Link
        className="inline-block px-6 py-2 text-white transition-all duration-500 ease-in-out rounded-full bg-azul border-azul hover:bg-rojo"
        to={`/distrito-${distrito}/`}>
        <ArrowLeftIcon size={16} />
        Volver a las listas del distrito {distrito}
      </Link>
    </div>
  )
}

export default OtherLists
